import { environment } from '../../../environments/environment';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let __webpack_require__: any;

export function setRuntimeConfigurations() {
  if (window.viewContext && window.viewContext.codeLocation) {
    __webpack_require__.p = `${window.viewContext.codeLocation}/${environment?.localhost ? '' : `${window.viewContext.clientVersion}/apps/web/`}`;
  }
}
